export class Taxonomy {
    id: number;
    name: string;
    
    constructor(data){
        this.id = data.id ? data.id : null;
        this.name = data.name ? data.name : null;
    }
}
